<template>
  <ExActionsPopUp
    v-if="view"
    :value="show"
    :headline="view.headline"
    :htmlInfo="view.htmlInfo"
    :destructive="view.destructive"
    :primary="view.primary"
    :termination="view.termination"
    :actionLabel="view.actionLabel"
    :centerHeadline="true"
    actionsTopSpacing="32px"
    @onAction="$emit('onConfirm')"
    @input="$emit('onClose')"
    :data-testid="`job-family-${view.action}-popup`"
    :applyBorderClass="true"
    :backgroundPatternBottomRight="true"
    :width="450"
    :errorMessage="errorMessage"
  />
</template>

<script>
export default {
  name: "JobFamilyConfirmDialog",
};
</script>

<script setup>
import { computed } from "vue";
import ExActionsPopUp from "@components/common/ExActionsPopUp.vue";
import { confirmViewFor } from "./jobFamilyConfirmDialog.js";

const props = defineProps({
  show: {
    type: Boolean,
    default: false,
  },
  action: {
    type: String,
    default: "activate",
  },
  name: {
    type: String,
    default: "",
  },
  errorMessage: {
    type: String,
    default: "",
  },
});

defineEmits(["onConfirm", "onClose"]);

const view = computed(() => confirmViewFor(props.action, props.name));
</script>
